import React, { Fragment } from 'react';
import InfiniteScrollTable from "../../infinite-scroll-table";
import { Select} from "antd";
import {translate} from "react-i18next";
import { compose } from 'redux';
import { EL_ATTRIBUTE_REFERS_DATASET, EL_ATTRIBUTE_REFERS_DIMENSION, EL_ATTRIBUTE_REFERS_OBSERVATION, EL_COL_TYPE_ATTRIBUTE, EL_COL_TYPE_DIMENSION, getELAtributeRefersTranslations } from '../constants';
import { MARGIN_MD } from '../../../styles/constants';
import Selector from '../../selector';
import { getStringFromArtefactTriplet } from '../../../utils/sdmxJson';

const TABLE_COL_WIDTH = 300;
const TABLE_SELECT_WIDTH = 200;

const TABLE_COL_DIM_WIDTH = 400;
const TABLE_SELECT_DIM_WIDTH = 300;

const ELAttributesStepTable = ({
                                t,
                                structureColumns,
                                setRowToAssociateCodelist,
                                onChange,    
                              }) => {

  const attributes = (structureColumns || []).filter(column => column.type === EL_COL_TYPE_ATTRIBUTE);
  const dimensions = (structureColumns || []).filter(column => column.type === EL_COL_TYPE_DIMENSION)
  
  const columns = [      
    {
      title: t('components.easyLoading.attributes.table.id.title'),
      dataIndex: "id"
    },
    {
      title: t('components.easyLoading.attributes.table.refers.title'),
      dataIndex: "refers",
      width: TABLE_COL_WIDTH,
      noFilter: true,
      noSort: true,
      render: (refers, row) => {
        return (
            <Select
              style={{marginRight: MARGIN_MD, width: TABLE_SELECT_WIDTH}}
              value={refers}
              onChange={(value) => {
                onChange(row.id, value, null, null)  
              }}
            >
              {[
                EL_ATTRIBUTE_REFERS_OBSERVATION,
                EL_ATTRIBUTE_REFERS_DIMENSION,
                EL_ATTRIBUTE_REFERS_DATASET
              ].map(opt =>
                <Select.Option
                  key={opt}
                  value={opt}
                  title={getELAtributeRefersTranslations(t)[opt]}
                  >
                  {getELAtributeRefersTranslations(t)[opt]}
                </Select.Option>
              )}
            </Select>
        )
      }
    },
    {
      title: t('components.easyLoading.attributes.table.dimensions.title'),
      dataIndex: "referredDimensions",
      width: TABLE_COL_DIM_WIDTH,
      noFilter: true,
      noSort: true,
      render: (referredDimensions, row) => {
        return (
          row.attributeDefinition.refers === EL_ATTRIBUTE_REFERS_DIMENSION 
          ? <Select
              mode="multiple"
              style={{marginRight: MARGIN_MD, width: TABLE_SELECT_DIM_WIDTH}}
              value={referredDimensions !== null ? referredDimensions : undefined}
              onChange={(arr) => {                
                onChange(row.id, row.attributeDefinition.refers, arr, row.attributeDefinition.association)  
              }}
            >
              {dimensions.map(dim =>
                <Select.Option 
                  key={dim.id} 
                  value={dim.id}
                  title={dim.id}
                >
                  {dim.id}
                </Select.Option>
              )}
            </Select>
          : null
        )
      }
    },    
    {
      title: t('components.easyLoading.attributes.table.association.title'),
      dataIndex: "association",
      width: TABLE_COL_WIDTH,
      noFilter: true,
      noSort: true,
      render: (association, row) => {
        return (
            <Selector
              selectTitle={t('components.easyLoading.attributes.table.association.selector.selectTitle')}
              resetTitle={t('components.easyLoading.attributes.table.association.selector.resetTitle')}
              onSelect={() => setRowToAssociateCodelist(row)}
              onReset={() => onChange(row.id, row.attributeDefinition.refers,row.attributeDefinition.dimensions, null)}
              value={association}
              render={codelist => codelist
                ? getStringFromArtefactTriplet(codelist)
                : ""}
            />
          )          
        }                
    }];   

  return ( 
    <Fragment>            
      <InfiniteScrollTable
        data={attributes.map(attribute => ({
          ...attribute,
          refers: attribute.attributeDefinition.refers,
          referredDimensions: attribute.attributeDefinition.dimensions,
          association: attribute.attributeDefinition.association
        }))}
        getRowKey={row => row.id}
        columns={columns}
      />
      
    </Fragment>
  )
};

export default compose(
  translate()
)(ELAttributesStepTable);


// WEBPACK FOOTER //
// ./src/components/easy-loading/attributes-step/Table.jsx